class AccordionFilters {
    constructor(elem) {
        this.elem = elem;
        this.button = this.elem.querySelector("[data-accordion-filter-button]");
        this.content = this.elem.querySelector(
            "[data-accordion-filter-content]",
        );
    }

    init() {
        // Supprimer l'ancien listener s'il existe pour éviter les doublons
        if (this.button && this.button._accordionHandler) {
            this.button.removeEventListener(
                "click",
                this.button._accordionHandler,
            );
        }

        // Créer le handler et le stocker sur l'élément
        this.button._accordionHandler = (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            this.toggleAccordion(this.elem);
        };

        // Ajouter le listener
        this.button.addEventListener("click", this.button._accordionHandler);
    }

    toggleAccordion(elem) {
        if (elem.classList.contains("is-open")) {
            this.closeContent(elem);
        } else {
            this.openContent(elem);
        }
    }

    openContent(content) {
        content.classList.add("is-open");
    }

    closeContent(content) {
        content.classList.remove("is-open");
    }
}

// Fonction pour initialiser tous les accordéons
function initAccordionFilters() {
    const accordionFilters = document.querySelectorAll(
        "[data-accordion-filter]",
    );

    if (accordionFilters) {
        accordionFilters.forEach((item) => {
            const accordion = new AccordionFilters(item);
            accordion.init();
        });
    }
}

// Initialisation au chargement de la page
initAccordionFilters();

// Hook pour les composants Livewire qui se chargent
document.addEventListener("initAccordionFilters", () => {
    setTimeout(() => {
        initAccordionFilters();
    }, 50);
});
